import { useTranslation } from 'react-i18next';
import React from 'react';

export function ZeroSalesPriceHint({
    onClick,
    orderingOrganizationName,
    isBillingRelevant,
}: {
    onClick: () => void;
    orderingOrganizationName?: string;
    isBillingRelevant: boolean;
}) {
    const { t } = useTranslation();

    const descriptionLabel = isBillingRelevant
        ? t('sections.productSelection.productPositionFooter.salesPricePositionConfiguration', {
              orgName: orderingOrganizationName,
          })
        : t('sections.productSelection.productPositionFooter.zeroSalesInfoText', {
              orgName: orderingOrganizationName,
          });

    const buttonLabel = isBillingRelevant
        ? t('sections.productSelection.productPositionFooter.doNotShowPosition')
        : t('sections.productSelection.productPositionFooter.showPosition');

    return (
        <div
            className="font-copy-sm text-subdued @3xl:flex-row @3xl:justify-between flex flex-col gap-2"
            data-test="zero-sales-price-hint"
        >
            <span>{descriptionLabel}</span>
            <button
                type="button"
                className="font-copy-sm-strong cursor-pointer whitespace-nowrap border-none bg-transparent p-0"
                onClick={onClick}
                name="zero-sales-price-toggle"
            >
                {buttonLabel}
            </button>
        </div>
    );
}

export function ZeroPurchasePriceHint({
    onClick,
    partnerOrganizationName,
    isBillingRelevant,
}: {
    onClick: () => void;
    partnerOrganizationName?: string;
    isBillingRelevant: boolean;
}) {
    const { t } = useTranslation();

    const descriptionLabel = isBillingRelevant
        ? t('sections.productSelection.productPositionFooter.purchasePricePositionConfiguration', {
              orgName: partnerOrganizationName,
          })
        : t('sections.productSelection.productPositionFooter.zeroPurchaseInfoText', {
              orgName: partnerOrganizationName,
          });

    const buttonLabel = isBillingRelevant
        ? t('sections.productSelection.productPositionFooter.doNotShowPosition')
        : t('sections.productSelection.productPositionFooter.showPosition');

    return (
        <div
            className="font-copy-sm text-subdued @3xl:flex-row @3xl:justify-between flex flex-col gap-2"
            data-test="zero-purchase-price-hint"
        >
            <span>{descriptionLabel}</span>
            <button
                type="button"
                className="font-copy-sm-strong cursor-pointer whitespace-nowrap border-none bg-transparent p-0"
                onClick={onClick}
                name="zero-purchase-price-toggle"
            >
                {buttonLabel}
            </button>
        </div>
    );
}

export function NegativeSalesPriceHint({ orderingOrganizationName }: { orderingOrganizationName?: string }) {
    const { t } = useTranslation();
    return (
        <div className="font-copy-sm text-subdued">
            {t('sections.productSelection.productPositionFooter.negativeSalesInfoText', {
                orgName: orderingOrganizationName,
            })}
        </div>
    );
}

export function NegativePurchasePriceHint({ partnerOrganizationName }: { partnerOrganizationName?: string }) {
    const { t } = useTranslation();
    return (
        <div className="font-copy-sm text-subdued">
            {t('sections.productSelection.productPositionFooter.negativePurchaseInfoText', {
                orgName: partnerOrganizationName,
            })}
        </div>
    );
}
